/* ============================================================
   ROBA LUCA — de cookiebanner

   Eigen paneel, Shopify's motor. Elke knop hier eindigt in
   Shopify.customerPrivacy.setTrackingConsent(), dezelfde aanroep
   die Shopify's gratis banner doet. Daardoor blijven de dingen
   die je niet zelf wil onderhouden bij Shopify: in welke landen
   de vraag gesteld moet worden, hoe de keuze onthouden wordt, en
   het doorgeven aan de pixels en de checkout.

   ⚠️ Wat die aanroep NIET doet: scripts tegenhouden die je zelf
   in het thema plakt. Daarom wacht rl-posthog.liquid zelf op de
   keuze. Apps die Shopify's Customer Privacy API volgen, zoals
   Klaviyo, houden zich er wel aan (live getest op 28/09, zie
   docs/research/consent-tracking-onderzoek-v2-28092026.md).

   Ingeladen met defer vanuit snippets/rl-head.liquid, alleen als
   de instelling aanstaat.

   03/10/2026: twee toevoegingen. Bij een weigering worden de
   cookies van Google, Meta en Klaviyo die er al lagen nu ook
   gewist (zie "Opruimen"), en een link met #cookie-settings opent
   het paneel nu ook als je er rechtstreeks op binnenkomt, bv.
   vanuit een mail (zie "Aanzetten").

   06/10/2026: ontbreekt het consent-signaal op de pagina (in
   Safari na een doorverwijzing via een ander domein), dan halen we
   het eerst op voor we iets beslissen (zie "Het signaal ophalen").
   En na een gelukte keuze zetten we de waarde die Shopify teruggaf
   in zijn opgeslagen kopie (zie "De keuze wegschrijven"). De
   knoppen zelf gedragen zich zoals voorheen. Metingen en
   achtergrond: docs/shop/theme-custom-code.md §95.
   ============================================================ */
(function () {
  'use strict';

  var WORTEL = document.getElementById('RlConsent');
  if (!WORTEL) return;

  var PANEEL = WORTEL.querySelector('.rl-consent__paneel');
  var privacy = null;
  var laatsteFocus = null;
  var magSluiten = false;

  /* ----------------------------------------------------------
     Open en dicht

     magSluiten staat op false zolang er nog geen keuze gemaakt
     is. Wegklikken of Escape mag dan niets doen: niets kiezen is
     geen toestemming, dus het paneel mag ook niet weggaan alsof
     er iets gekozen is. Heeft de bezoeker al eens gekozen en
     opent hij het paneel zelf opnieuw, dan mag Escape wel.
     ---------------------------------------------------------- */
  var toon = function (herbezoek) {
    magSluiten = !!herbezoek;
    laatsteFocus = document.activeElement;
    WORTEL.setAttribute('data-rl-laag', herbezoek ? '2' : '1');
    WORTEL.setAttribute('data-rl-open', '');
    document.body.classList.add('overflow-hidden');
    if (herbezoek) vulKeuzes();
    window.requestAnimationFrame(function () {
      var eerste = PANEEL.querySelector('button');
      (eerste || PANEEL).focus();
    });
  };

  var verberg = function () {
    WORTEL.removeAttribute('data-rl-open');
    document.body.classList.remove('overflow-hidden');
    if (laatsteFocus && laatsteFocus.focus) laatsteFocus.focus();
  };

  /* ----------------------------------------------------------
     Het signaal ophalen (toegevoegd 06/10/2026)

     Shopify stuurt de toestemming van de bezoeker mee met elke
     pagina, in de kop Server-Timing (_cmp). Zijn script leest die
     via performance.getEntriesByType('navigation') en bewaart een
     kopie in sessionStorage ('consentHeader'). Heeft een pagina
     geen eigen signaal, dan valt het terug op die kopie.

     Safari geeft dat signaal niet door als de pagina via een ander
     domein binnenkwam. Gemeten op 06/10 in WebKit, de motor van
     Safari: de tweede pagina van een nieuw bezoek loopt via
     shop.app, en wie op www.robaluca.com binnenkomt, gaat via een
     doorverwijzing. Chrome geeft het in beide gevallen wel door.

     Wat er zonder deze stap gebeurde: op zo'n pagina las Shopify's
     script de kopie van de vorige pagina, dus van vóór de keuze, en
     het paneel kwam terug. Of er was nog geen kopie: dan kwam er
     geen paneel en meldde de API dat analytics mocht.

     Daarom: heeft deze pagina geen eigen signaal, dan vragen we het
     één keer op met een kleine aanvraag naar /cart.js (die draagt
     dezelfde kop) en zetten we het in die kopie, zoals Shopify's
     script dat op een gewone pagina zelf doet. Pas daarna beslissen
     we. In Chrome, en op elke gewone pagina, gebeurt hier niets.

     ⚠️ 'consentHeader' en de kop _cmp zijn van Shopify en staan niet
     in hun documentatie. Verandert dat ooit, dan doet deze stap
     niets meer, zonder schade: de banner gedraagt zich dan weer zoals
     vóór 06/10, en rl-posthog.liquid laadt nog altijd niet zolang
     Shopify geen signaal heeft.
     ---------------------------------------------------------- */
  var SLEUTEL = 'consentHeader';

  var signaalOpPagina = function () {
    try {
      var nav = window.performance.getEntriesByType('navigation')[0];
      return !!(nav && nav.serverTiming && nav.serverTiming.some(function (e) {
        return e.name === '_cmp';
      }));
    } catch (e) {
      return true; /* bij twijfel niets doen */
    }
  };

  var bewaarSignaal = function (waarde) {
    if (!waarde) return;
    try { waarde = decodeURIComponent(waarde); } catch (e) {}
    try { window.sessionStorage.setItem(SLEUTEL, waarde); } catch (e) {}
  };

  var haalSignaal = function (verder) {
    if (signaalOpPagina() || !window.fetch) {
      verder();
      return;
    }
    var gedaan = false;
    var eenmaal = function () {
      if (gedaan) return;
      gedaan = true;
      verder();
    };
    /* Nooit langer dan 3 s wachten. Lukt het niet, dan beslist
       Shopify's script met wat het heeft, zoals voorheen. */
    var wacht = window.setTimeout(eenmaal, 3000);
    window.fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (antwoord) {
        var kop = antwoord.headers.get('server-timing') || '';
        var gevonden = kop.match(/(?:^|[\s,])_cmp;desc="([^"]*)"/);
        if (gevonden) bewaarSignaal(gevonden[1]);
      })
      .catch(function () {})
      .then(function () {
        window.clearTimeout(wacht);
        eenmaal();
      });
  };

  /* rl-posthog.liquid wacht hierop voor het iets beslist. */
  var meldKlaar = function () {
    window.rlConsentKlaar = true;
    try {
      document.dispatchEvent(new CustomEvent('rl:consent-klaar'));
    } catch (e) {}
  };

  /* ----------------------------------------------------------
     De keuze wegschrijven

     sale_of_data loopt mee met marketing. Dat is de Amerikaanse
     (CCPA) en Shopify zet die pagina zelf op "Not required for
     regions you're selling in", dus hij speelt hier niet -- maar
     hem leeg laten geeft een half ingevuld dossier, en het is
     hoe dan ook een marketingdoel. Wie marketing weigert, weigert
     dit dus ook. Strenger kan het nooit worden dan wat de bezoeker
     bij marketing gekozen heeft.

     06/10/2026: lukt het wegschrijven, dan zetten we de waarde die
     Shopify net teruggaf ook in zijn opgeslagen kopie (zie "Het
     signaal ophalen"), zodat een volgende pagina zonder eigen
     signaal de keuze ook kent.

     Het paneel gaat dicht na het antwoord van Shopify, ook als het
     wegschrijven mislukte. Bewust zo gelaten (zie §95): een
     mislukte keuze bewaart niets, dus er wordt ook niets gevolgd,
     en de vraag komt op de volgende pagina vanzelf terug. Het
     paneel openhouden met een foutmelding zou bij een storing bij
     Shopify de hele winkel blokkeren, en dat kost verkoop.
     ---------------------------------------------------------- */
  var bewaar = function (keuze) {
    if (!privacy) return;
    try {
      privacy.setTrackingConsent(
        {
          analytics: !!keuze.analytics,
          marketing: !!keuze.marketing,
          preferences: !!keuze.preferences,
          sale_of_data: !!keuze.marketing
        },
        function (fout, data) {
          if (!fout) {
            var cookies = data && data.data && data.data.consentManagement &&
              data.data.consentManagement.cookies;
            bewaarSignaal(cookies && cookies.trackingConsentCookie);
          }
          ruimOp();
          verberg();
        }
      );
    } catch (e) {
      /* Valt de aanroep zelf meteen om (komt in de praktijk niet
         voor, de invoer ligt vast), dan blijft het paneel staan,
         zoals voorheen. */
    }
  };

  var uitVakjes = function () {
    var keuze = {};
    WORTEL.querySelectorAll('[data-rl-soort]').forEach(function (vakje) {
      keuze[vakje.getAttribute('data-rl-soort')] = vakje.checked;
    });
    return keuze;
  };

  /* De API geeft '' als er nog niets gekozen is, en daarna 'yes'
     of 'no'. Ouder gedrag gaf booleans, dus allebei opvangen. */
  var vulKeuzes = function () {
    if (!privacy) return;
    var nu = {};
    try { nu = privacy.currentVisitorConsent() || {}; } catch (e) { return; }
    WORTEL.querySelectorAll('[data-rl-soort]').forEach(function (vakje) {
      var waarde = nu[vakje.getAttribute('data-rl-soort')];
      vakje.checked = waarde === true || waarde === 'yes';
    });
  };

  /* ----------------------------------------------------------
     Opruimen na een weigering (toegevoegd 03/10/2026)

     setTrackingConsent() houdt de pixels tegen, maar wist de
     cookies niet die ze eerder zetten. Wie eerst "Accept all"
     klikte en later weigert, hield _ga, _fbp en __kla_id tot ze
     vanzelf vervielen. Ze werden niet meer gebruikt (nagemeten op
     03/10), maar een ingetrokken toestemming hoort ook de opslag
     te stoppen.

     Welke cookie bij welke keuze hoort, volgt hoe Shopify de
     pixels zelf laadt: de Meta-pixel en Klaviyo vragen allebei
     analytics en marketing, dus een nee op een van de twee is
     genoeg om hun cookies weg te halen. Google Analytics hangt
     aan analytics, de advertentiecookie van Google aan marketing.

     Draait na elke keuze en bij elke paginalading, zodat ook een
     weigering van voor deze code, of uit een ander tabblad, wordt
     opgeruimd. Alleen bij een uitdrukkelijke "no": wie nog niets
     koos, kreeg in de EU ook nog niets.
     ---------------------------------------------------------- */
  var OPRUIMEN = [
    { bij: ['analytics'], namen: [/^_ga$/, /^_ga_/, /^_gid$/, /^_gat/] },
    { bij: ['marketing'], namen: [/^_gcl_/] },
    { bij: ['analytics', 'marketing'], namen: [/^_fbp$/, /^_fbc$/, /^__kla_id$/] }
  ];

  /* Een cookie verdwijnt alleen als je hem wist met hetzelfde
     domein waarmee hij gezet is. Google zet hem op robaluca.com,
     Klaviyo zonder domein. Alle varianten proberen kost niets. */
  var wis = function (naam) {
    var host = window.location.hostname;
    var basis = host.replace(/^www\./, '');
    ['', host, basis, '.' + basis].forEach(function (domein) {
      document.cookie =
        naam + '=; Max-Age=0; path=/' + (domein ? '; domain=' + domein : '');
    });
  };

  var ruimOp = function () {
    if (!privacy) return;
    var nu = {};
    try { nu = privacy.currentVisitorConsent() || {}; } catch (e) { return; }
    var geweigerd = function (soort) {
      return nu[soort] === 'no' || nu[soort] === false;
    };
    var weg = [];
    OPRUIMEN.forEach(function (regel) {
      if (regel.bij.some(geweigerd)) weg = weg.concat(regel.namen);
    });
    if (!weg.length) return;
    document.cookie.split(';').forEach(function (stuk) {
      var naam = stuk.split('=')[0].trim();
      if (!naam) return;
      if (weg.some(function (patroon) { return patroon.test(naam); })) wis(naam);
    });
  };

  /* ----------------------------------------------------------
     De knoppen
     ---------------------------------------------------------- */
  WORTEL.addEventListener('click', function (event) {
    var knop = event.target.closest('[data-rl-consent]');
    if (!knop) return;

    switch (knop.getAttribute('data-rl-consent')) {
      case 'alles':
        bewaar({ analytics: true, marketing: true, preferences: true });
        break;
      case 'niets':
        bewaar({ analytics: false, marketing: false, preferences: false });
        break;
      case 'kiezen':
        WORTEL.setAttribute('data-rl-laag', '2');
        break;
      case 'terug':
        WORTEL.setAttribute('data-rl-laag', '1');
        break;
      case 'bewaren':
        bewaar(uitVakjes());
        break;
    }
  });

  /* Escape, en alleen als er al een keuze ligt. */
  document.addEventListener('keydown', function (event) {
    if (!WORTEL.hasAttribute('data-rl-open')) return;

    if (event.key === 'Escape' && magSluiten) {
      verberg();
      return;
    }

    /* De focus binnen het paneel houden. Een dialoog die je met
       Tab kan verlaten terwijl de pagina eronder onbereikbaar is,
       laat je met de cursor in het niets staan. */
    if (event.key !== 'Tab') return;
    var elementen = PANEEL.querySelectorAll(
      'button:not([disabled]), a[href], input:not([disabled])'
    );
    if (!elementen.length) return;
    var eerste = elementen[0];
    var laatste = elementen[elementen.length - 1];

    if (event.shiftKey && document.activeElement === eerste) {
      event.preventDefault();
      laatste.focus();
    } else if (!event.shiftKey && document.activeElement === laatste) {
      event.preventDefault();
      eerste.focus();
    }
  });

  /* ----------------------------------------------------------
     Opnieuw openen

     Een link naar #cookie-settings volstaat, waar hij ook staat --
     een menu-item in de footer, een link in de privacyverklaring.
     Geen extra code per plek, en het werkt ook als Lucas hem
     morgen ergens anders zet.
     ---------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var link = event.target.closest(
      'a[href$="#cookie-settings"], a[href$="#cookie-instellingen"], [data-rl-consent-open]'
    );
    if (!link) return;
    event.preventDefault();
    toon(true);
  });

  /* ----------------------------------------------------------
     Aanzetten

     shouldShowBanner() is van Shopify en kent de regio's uit
     Settings → Customer privacy. Staat de bezoeker buiten die
     regio's, of heeft hij al gekozen, dan is het false en tonen
     we niets.

     In de thema-editor niet vanzelf openen: een paneel over de
     hele pagina maakt het bewerken onmogelijk. Daar kan je hem
     nog altijd openen met een link naar #cookie-settings.

     🔴 shouldShowBanner() alleen volstaat niet. Die blijft true
     nadat er gekozen is -- nagemeten op 21/09: na "Save choices"
     stond currentVisitorConsent() op yes/no/no en gaf
     shouldShowBanner() nog steeds true, ook op een verse
     paginalading. Gevolg: het paneel kwam op elke pagina terug.
     shouldShowGDPRBanner() gaf op datzelfde moment wel false.

     In plaats van te gokken welke methode welke wetgeving dekt,
     splitsen we de vraag: Shopify beslist of er in deze regio
     überhaupt gevraagd moet worden, en wij kijken in zijn eigen
     dossier of het al beantwoord is. Een geweigerde keuze staat
     daar als "no" -- ook een antwoord, dus ook niet meer vragen.
     ---------------------------------------------------------- */
  var moetVragen = function () {
    if (!privacy.shouldShowBanner()) return false;
    var nu = privacy.currentVisitorConsent() || {};
    return !(nu.analytics || nu.marketing || nu.preferences);
  };

  /* Rechtstreeks binnenkomen op een link met #cookie-settings
     (bv. vanuit een mail) opent het paneel nu ook. Tot 03/10
     werkte dat alleen met een klik op een link op de site zelf.
     De hash gaat daarna uit de adresbalk, anders opent het paneel
     bij elke herlaadbeurt opnieuw. */
  var vanuitLink = function () {
    var hash = window.location.hash;
    if (hash !== '#cookie-settings' && hash !== '#cookie-instellingen') return false;
    if (window.history && window.history.replaceState) {
      window.history.replaceState(
        null, '', window.location.pathname + window.location.search
      );
    }
    return true;
  };

  if (!window.Shopify || !window.Shopify.loadFeatures) {
    meldKlaar();
    return;
  }

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    function (fout) {
      if (fout) {
        meldKlaar();
        return;
      }
      privacy = window.Shopify.customerPrivacy;
      if (!privacy) {
        meldKlaar();
        return;
      }
      /* Eerst het signaal, dan pas beslissen (zie "Het signaal
         ophalen"). Op een gewone pagina gaat dit meteen door. */
      haalSignaal(function () {
        meldKlaar();
        ruimOp();
        if (window.Shopify.designMode) return;
        try {
          if (moetVragen()) toon(false);
          else if (vanuitLink()) toon(true);
        } catch (e) {}
      });
    }
  );
})();
